// extracted by mini-css-extract-plugin
export default {"container":"EditingOrganizationSummary-module__container--bmlPW","buttons":"EditingOrganizationSummary-module__buttons--u5-F8"};